import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface FieldProps {
  icon?: React.ReactNode;
  label: string;
  children: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ icon, label, children }) => (
  <Box sx={{ minWidth: 200 }}>
    <Stack direction="row" gap={0.5} alignItems="center" sx={{ color: '#64748b' }}>
      {icon}
      <Typography variant="caption">{label}</Typography>
    </Stack>
    <Typography variant="body2" sx={{ color: '#1e293b', mt: 0.5 }}>
      {children}
    </Typography>
  </Box>
);

export default Field;
